const cfg:Conifg = {
  baseUrl: 'http://127.0.0.1:8011',
  showIcp: true
}

export default cfg